import clsx from "clsx";
import type { HotelWebsite } from "../format";

/**
 * The hotel's own site, opened in a new tab.
 *
 * The click stops propagating: this renders inside surfaces that navigate on
 * click of their own (a fleet row opens the hotel), and a click on a link must
 * do one thing. Colour is inherited so the link sits quietly in whatever line
 * carries it, and declares itself on hover.
 */
export function WebsiteLink({
  website,
  className,
}: {
  website: HotelWebsite;
  className?: string;
}) {
  return (
    <a
      href={website.href}
      target="_blank"
      rel="noopener noreferrer"
      data-tip={website.href}
      onClick={(event) => event.stopPropagation()}
      className={clsx("hover:text-brand-primary hover:underline", className)}
    >
      {website.label}
    </a>
  );
}
